import ArrowBack from "@mui/icons-material/ArrowBack";
import {
  Box,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import type { TranslationKeyAndOptions } from "@thalamos/vision-common";

import { Translation } from "../../Translation/Translation.js";

///

export type HeaderProps = {
  title: TranslationKeyAndOptions;
  page: number;
  totalPages: number;
  onBack?: () => void;
};

export const Header = (props: HeaderProps) => (
  <HeaderInner type={"loaded"} {...props} />
);

///

export type HeaderSkeletonProps = Pick<HeaderProps, "title">;

export const HeaderSkeleton = ({ title }: HeaderSkeletonProps) => (
  <HeaderInner type={"loading"} title={title} />
);

///

type HeaderInnerProps =
  | ({ type: "loading" } & HeaderSkeletonProps)
  | ({ type: "loaded" } & HeaderProps);

export const HeaderInner = (props: HeaderInnerProps) => {
  const { t } = useTranslation();
  return (
    <Stack>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <IconButton
          disabled={props.type === "loading" || props.onBack === undefined}
          onClick={props.type === "loading" ? undefined : props.onBack}
          aria-label={t("multiPageForm.cancel")}
        >
          <ArrowBack />
        </IconButton>
        <Typography>
          <Translation {...props.title} />
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={
          props.type === "loading"
            ? 0
            : (100 * (props.page + 1)) / props.totalPages
        }
        aria-label={t("multiPageForm.pageProgressLabel")}
      />
    </Stack>
  );
};
